import React, { useEffect } from 'react'

const Blog = () => {
	useEffect(()=>{
							/* === start ASIDE ==== */
							if (document.querySelector(".drop")) {
								const lists = document.querySelectorAll(".drop");
								dropList(lists);
				
								function dropList(els) {
									els.forEach((el) => {
										el.addEventListener("click", (e) => {
											e.currentTarget.classList.toggle("show");
											let content = e.currentTarget.nextElementSibling;
											if (content.style.maxHeight) {
												content.style.maxHeight = null;
											} else {
												content.style.maxHeight = content.scrollHeight + "px";
											}
										});
									});
								}
							}
									/* === end ASIDE ==== */


					/* === start ASIDE ==== */
					if (document.querySelector(".dropaa")) {
						const lists = document.querySelectorAll(".dropaa");
						dropList(lists);
		
						function dropList(els) {
							els.forEach((el) => {
								el.addEventListener("click", (e) => {
									e.currentTarget.classList.toggle("show");
									let content = e.currentTarget.nextElementSibling;
									if (content.style.maxHeight) {
										content.style.maxHeight = null;
									} else {
										content.style.maxHeight = content.scrollHeight + "px";
									}
								});
							});
						}
					}
							/* === end ASIDE ==== */

														
	},[])
  return (
    <div>
  <main className="page-content">
    <div className="tm-section tm-blogs-page tm-padding-section bg-white">
      <div className="container">
        <div className="row">
          {/* <div class="col-lg-3 col-12">
							<div class="toggle-two">
								<div class="div toggle-middle-btn" id="wrapper">
									<button id="button-wrapper"><span id="button" class="menu-button" role="button"><i class="ion-android-menu android-menu-aa"></i></span></button>
									<strong style="float: right;padding: 7px 10px 0 0;">Categorys</strong>
								</div>
								<div id="menu" class="widgets widgets-one menu-container">
									<div class="accordion" id="accordionExample">
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingOne">
												<button class="accordion-button drop" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
													Category
												</button>
											</h2>
											<div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<div class="category-four-box">
														<form>
															<div class="form-group-three">
																<input type="checkbox" id="Rings">
																<label for="Rings">Rings</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Earring">
																<label for="Earring">Earring</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="pandants">
																<label for="pandants">Pandants</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="sets">
																<label for="sets">Sets</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="bangles">
																<label for="bangles">Bangles</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Cufflinks">
																<label for="Cufflinks">Cufflinks</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Locket">
																<label for="Locket">Locket</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Diamond">
																<label for="Diamond">Diamond</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Necklace">
																<label for="Necklace">Necklace</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Turquoise">
																<label for="Turquoise">Turquoise</label>
															</div>
															<div class="form-group-three">
																<input type="checkbox" id="Diamond1">
																<label for="Diamond1">Diamond</label>
															</div>
														</form>
													</div>
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingTwo">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
													Gender
												</button>
											</h2>
											<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													Women
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingThree">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
													Color
												</button>
											</h2>
											<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<form>
														<div class="form-group-three">
															<input type="checkbox" id="Beige">
															<label for="Beige">Beige</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="Grey">
															<label for="Grey">Grey</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="Blue">
															<label for="Blue">Blue</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="Brown">
															<label for="Brown">Brown</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="Multicolor">
															<label for="Multicolor">Multicolor</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="Pink">
															<label for="Pink">Light Pink</label>
														</div>
													</form>
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingfour">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
													Size
												</button>
											</h2>
											<div id="collapsefour" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<form>
														<div class="form-group-three">
															<input type="checkbox" id="aa">
															<label for="aa">10</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="bb">
															<label for="bb">10XL</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="cc">
															<label for="cc">26</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="dd">
															<label for="dd">28</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="ee">
															<label for="ee">30</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="ff">
															<label for="ff">32</label>
														</div>
													</form>
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingfour">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
													Price
												</button>
											</h2>
											<div id="collapsefive" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<form>
														<div class="form-group-three">
															<input type="checkbox" id="aaa">
															<label for="aaa">Under ₹ 149</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="bbb">
															<label for="bbb">Under ₹ 199</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="ccc">
															<label for="ccc">Under ₹ 249</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="ddd">
															<label for="ddd">Under ₹ 299</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="eee">
															<label for="eee">Under ₹ 349</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="fff">
															<label for="fff">₹ 0 - ₹ 99</label>
														</div>
													</form>
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingfour">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesex" aria-expanded="false" aria-controls="collapsesex">
													Rating
												</button>
											</h2>
											<div id="collapsesex" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<form>
														<div class="form-group-three">
															<input type="checkbox" id="aaaa">
															<label for="aaaa">2.0 and above</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="bbbb">
															<label for="bbbb">3.0 and above</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="cccc">
															<label for="cccc">3.5 and above</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="dddd">
															<label for="dddd">4.0 and above</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="eeee">
															<label for="eeee">M-Trusted</label>
														</div>
													</form>
												</div>
											</div>
										</div>
										<div class="accordion-item">
											<h2 class="accordion-header" id="headingfour">
												<button class="accordion-button collapsed dropaa" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesiven" aria-expanded="false" aria-controls="collapsesiven">
													Type of Hair
												</button>
											</h2>
											<div id="collapsesiven" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
												<div class="accordion-body">
													<form>
														<div class="form-group-three">
															<input type="checkbox" id="aaaaa">
															<label for="aaaaa">All Hair Type</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="bbbbb">
															<label for="bbbbb">Curly Hair</label>
														</div>
														<div class="form-group-three">
															<input type="checkbox" id="ccccc">
															<label for="ccccc">Straight Hair</label>
														</div>
													</form>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> */}
          <div className="col-lg-12 col-12">
            <div className="row tm-blog-container mt-50-reverse">
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-1.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">Woman wearing
                        gold-colore ring
                        pendant necklaces</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-2.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">Shallow focus
                        photo of person
                        putting gold-colored ring</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-3.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">Silver-colored
                        tiara rings
                        with clear
                        gemstones</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-4.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">Diamond ring is
                        worn on top of
                        the
                        engagement band</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-5.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">White gold
                        engagement rings
                        for
                        couples</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mt-50">
                <div className="tm-blog tm-scrollanim">
                  <div className="tm-blog-topside">
                    <div className="tm-blog-thumb">
                      <img src="assets/images/blog/blog-image-6.jpg" alt="blog image" />
                    </div>
                    <span className="tm-blog-metahighlight"><span>Apr</span>17</span>
                  </div>
                  <div className="tm-blog-content">
                    <h6 className="tm-blog-title"><a href="blog-details.html">Woman wearing all kind
                        of gold
                        colore jewelery</a></h6>
                    <ul className="tm-blog-meta">
                      <li><a href="blog.html"><i className="ion-android-person" /> Anderson</a></li>
                      <li><a href="blog-details.html"><i className="ion-chatbubbles" /> 3 Comments</a></li>
                    </ul>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                      eiusmod tempor
                      incdidunt ut labore et dolore magna aliqua [....]</p>
                    <a href="#" className="tm-readmore">Read more</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tm-pagination mt-50">
              <ul>
                <li className="is-active"><a href="blog.html">1</a></li>
                <li><a href="blog.html">2</a></li>
                <li><a href="blog.html">3</a></li>
                <li><a href="blog.html">4</a></li>
                <li><a href="blog.html"><i className="ion-chevron-right" /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>

  )
}

export default Blog
